import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Paper adds font sizes Tailwind doesn't ship; without registering them, tailwind-merge reads
// `text-micro` as a text color and drops it when a real color like `text-ink` follows.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["micro", "badge"] }],
      "font-weight": [{ font: ["regular"] }],
      tracking: [{ tracking: ["caps"] }],
      leading: [{ leading: ["micro", "badge", "xs", "sm", "base", "lg", "xl", "2xl"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
